import React, { ReactNode } from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material';
import { useSelector } from 'react-redux';
import { PureLightTheme } from './schemes/PureLightTheme';
import { alpha, createTheme, lighten, darken } from '@mui/material';

interface RootState {
  theme: {
    themeColor: string;
  };
}

interface ThemeProviderWrapperProps {
  children: ReactNode;
}

const ThemeProviderWrapper: React.FC<ThemeProviderWrapperProps> = ({
  children
}) => {
  // Get primary color from Redux store
  const primaryColor = useSelector(
    (store: RootState) => store.theme.themeColor
  );

  // Create a new theme by merging the base theme with our custom primary color
  const theme = createTheme({
    ...PureLightTheme,
    colors: {
      ...PureLightTheme.colors,
      primary: {
        lighter: alpha(primaryColor, 0.1),
        light: lighten(primaryColor, 0.3),
        main: primaryColor,
        dark: darken(primaryColor, 0.2)
      }
    },
    palette: {
      ...PureLightTheme.palette,
      primary: {
        light: lighten(primaryColor, 0.3),
        main: primaryColor,
        dark: darken(primaryColor, 0.2),
        contrastText: '#fff'
      }
    }
  });

  return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
};

export default ThemeProviderWrapper;
